export default "__VITE_ASSET__b01e9227__"